'use client';

import { c as _c } from "react/compiler-runtime";
import type { SxProps } from '@mui/material';
import { Box } from '@mui/material';
import { type ReactNode, useRef } from 'react';
import { RoundupFiltersDesktop } from './Desktop';
import { RoundupFiltersMobile } from './Mobile';
export function RoundupFilters(t0) {
  const $ = _c(9);
  const {
    containerSx,
    isEnabled: t1,
    children
  } = t0;
  const isEnabled = t1 === undefined ? false : t1;
  const childRef = useRef(null);
  if (!isEnabled) {
    return children;
  }
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <RoundupFiltersDesktop contentRef={childRef} />;
    t3 = <RoundupFiltersMobile />;
    $[0] = t2;
    $[1] = t3;
  } else {
    t2 = $[0];
    t3 = $[1];
  }
  let t4;
  if ($[2] !== containerSx) {
    t4 = <Box sx={containerSx}>{t2}{t3}</Box>;
    $[2] = containerSx;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== children) {
    t5 = <div ref={childRef}>{children}</div>;
    $[4] = children;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t4 || $[7] !== t5) {
    t6 = <>{t4}{t5}</>;
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  return t6;
}